var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-vertical__item py-0"},[_c('span',[_vm._v(_vm._s(_vm.$t('org.noFiltersAvailableForThisSelection'))+".")])])}
var staticRenderFns = []

export { render, staticRenderFns }